import { Component } from '@angular/core';
import { NavComponent } from '../../nav/nav.component';

@Component({
	selector: 'app-authenticated',
	templateUrl: './authenticated.component.html',
	styleUrls: ['./authenticated.component.css'],
	imports: [NavComponent],
})
export class AuthenticatedComponent {
	constructor() {}
}
